import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MockApiService } from '@core/mock-api-setup/mockApi.service';
import { Observable, catchError, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

export enum BaseUrl {
  Frontend = "frontend_url",
  Base = "baseurl",
  FileUpload = "fileUploadurl",
}

@Injectable({
  providedIn: 'root'
})

export class ApiRequestService {

  constructor(
    private _HttpClient: HttpClient,
    private _MockApiService: MockApiService
  ) { }

  postData(path: string, payload?: any, baseUrl: BaseUrl = BaseUrl.Base): Observable<any> {
    let headers = new HttpHeaders()
    if (payload?.form) {
      headers = headers.set('from', payload.form);
    }
    let baseurl = environment[baseUrl];
    // baseurl = (path.includes('ticket') ? 'http://172.16.10.37/' : environment[baseUrl]);
    // (path.includes('ticket') ? 'http://172.16.10.82:81/' : environment[baseUrl])
    // .post<any>((path.includes('bbps')? 'http://172.16.10.82:81/': environment[baseUrl]) + (path ?? ''), payload?.payload ?? payload, { headers })
    // .post<any>(environment[baseUrl] + (path ?? ''), payload?.payload ?? payload, { headers })
    return this._MockApiService.getMockData(baseurl + path);
    return this._HttpClient
      .post<any>(baseurl + (path ?? ''), payload?.payload ?? payload, { headers })
      // .post<any>((path.includes('bbps')? 'http://172.16.10.104:81': environment[baseUrl]) + (path ?? ''), payload?.payload ?? payload, { headers })
      .pipe(retry(0), catchError(this.errorHandle));
  };

  getData(path: string, baseUrl: BaseUrl = BaseUrl.Base): Observable<any> {
    return this._HttpClient
      .get<any>(environment[baseUrl] + path)
      .pipe(retry(0), catchError(this.errorHandle));
  };

  private errorHandle(err: any) {
    //console.log(err);

    let error: any = '';
    if (err.error instanceof ErrorEvent) {
      error = err.error.message;
    } else {
      error = `Error Code: ${err.status}\nMessage: ${err.message}`;
    }
    return throwError(() => error)
  }
}
